import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ActivatedRoute,
  ActivationEnd,
  ActivationStart,
  Router,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { ChangePasswordComponent } from '../../../main/change-password/change-password.component';
import { ROUTES } from '../../../main/sidebar/sidebar.component';
import { DynamicDialogService } from '../../../shared/services/dynamic-dialog.service';
import { HeaderService } from '../../services/header.service';
import { NavSidebarService } from '../../services/nav-sidebar.service';
import { IconsList, LoginList } from '../../utils/constants';

@Component({
    selector: 'tded-header',
    styleUrls: ['header.component.scss'],
    templateUrl: 'header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit {
  private listTitles: any[];
  public pageTitle: string = '';
  public pageTitleList: string[] = [];
  location: Location;
  public sidebarVisible: boolean;
  public userName: string;
  public allowedChangePswd: boolean;
  imageURL!: string;
  isMinimized: boolean;
  @ViewChild('tded-header', { static: false }) button;

  isUserLoggedInPages = true;
  constructor(
    location: Location,
    private router: Router,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _navSidebarService: NavSidebarService,
    private readonly _dynamicDialogService: DynamicDialogService,
    private readonly _headerService: HeaderService
  ) {
    this.location = location;
    this.getAllowedLogins();

    this.router.events
      .pipe(
        filter((event): event is ActivationEnd => event instanceof ActivationEnd)
      )
      .subscribe((event: ActivationEnd) => {
        this.setPageTitle(event.snapshot.data || {});
      });
  }

  ngOnInit() {
    this.isUserLoggedInPages =
      !this._activatedRoute.snapshot.data.hasOwnProperty('no-login');

    this.userName = sessionStorage.getItem('userName');
    this.imageURL = sessionStorage.getItem('imageURL');
    this.listTitles = ROUTES.filter((listTitle) => listTitle);

    this._navSidebarService.isMinimized$.subscribe((value: boolean) => {
      this.isMinimized = value;
    });

    this.getDrawerStatus();

    this._headerService.pageTitles$.subscribe((titles: string[]) => {
      this.pageTitleList = titles;
    });
    // Set page title
    const child = this.getDeepestChild(this._activatedRoute);
    this.setPageTitle(child.snapshot.data || {});
  }

  getTitle() {
    let titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }
    for (let item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

  setPageTitle(data): void {
    if (data.TITLE) {
      this.pageTitle = data.TITLE;
    }
  }


  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  getAllowedLogins() {
    this.allowedChangePswd = false;
    const loginList = LoginList.LOGINTYPES.map((data) => data.name);
    const configSettings = JSON.parse(sessionStorage.getItem('configSettings'));
    loginList.forEach((data, index) => {
      if (
        configSettings &&
        configSettings.hasOwnProperty(data) &&
        configSettings[data] &&
        data === 'isLoginEmailAllowed'
      ) {
        this.allowedChangePswd = true;
      }
    });
  }

  toggleSidebar() {
    // Mobile: toggle sidebar slide in/out
    if (this._navSidebarService.isMobile()) {
      this._navSidebarService.sidebarMobileToggle();
    } else {
      // Desktop: toggle sidebar minimize (existing behavior)
      this._navSidebarService.sidebarWebToggle();
      this.router.navigate([], { relativeTo: this._activatedRoute });
    }
  }

  changePassword(): void {
    this._dynamicDialogService.showDialog<any>(
      ChangePasswordComponent,
      { formData: {} },
      'Change Password',
      IconsList.CHANGE_PASSWORD.ICON,
      'medium',
      this.callback.bind(this)
    );
  }

  callback() {
    return true;
  }

  getDrawerStatus() {
    let status = sessionStorage.getItem('hideDrawer');
    if (status && status == 'true') {
      sessionStorage.setItem('hideDrawer', 'true');
      document.getElementsByTagName('body')[0].classList.add('sidebar-mini');
    } else {
      sessionStorage.setItem('hideDrawer', 'false');
      document.getElementsByTagName('body')[0].classList.remove('sidebar-mini');
    }
  }
}
